import React from "react";

interface KeyboardIconProps {
    className?: string;
    color?: string;
    size?: "sm" | "md" | "lg" | "xl";
}

export const KeyboardIcon = ({
                                 className = "",
                                 color = "currentColor",
                                 size = "md",
                             }: KeyboardIconProps) => {
    const sizeClasses = {
        sm: "w-4 h-4",   // ~16x16px
        md: "w-6 h-6",   // ~24x24px
        lg: "w-7 h-7",   // ~28x28px
        xl: "w-10 h-10", // ~40x40px
    };

    return (
        <div className="icon keyboard-icon">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                className={`${sizeClasses[size]} ${className}`}
                aria-hidden="true"
            >
                {/* Dots */}
                <path d="M10 8h.01" strokeWidth={2} />
                <path d="M12 12h.01" strokeWidth={2} />
                <path d="M14 8h.01" strokeWidth={2} />
                <path d="M16 12h.01" strokeWidth={2} />
                <path d="M18 8h.01" strokeWidth={2} />
                <path d="M6 8h.01" strokeWidth={2} />
                <path d="M8 12h.01" strokeWidth={2} />

                {/* Everything else */}
                <path d="M7 16h10" strokeWidth={1.5} />
                <rect
                    width="20"
                    height="16"
                    x="2"
                    y="4"
                    rx="2"
                    strokeWidth={1.5}
                />
            </svg>
        </div>
    );
};

export default KeyboardIcon;